module.exports = __webpack_public_path__ + "static/media/verao-capa.6510c1e5.png";